"use client";

import { useSyncExternalStore } from "react";

// Trusted Types ilkesinin satır içi betiği (src/lib/security/trusted-types.ts) yalnızca sunucu HTML'inde: hidrasyonda
// sunucudaki öğe aynen kalır, sonra kaldırılır (ilke kurulmuş olur, betik bir daha çalışmaz). Sayfa tarayıcıda baştan
// çizilirse (404/hata kabuğu) hiç eklenmez: React istemcide eklenen <script>'i zaten çalıştırmaz ve geliştirmede
// "Encountered a script tag" uyarısı verirdi; o durumda ilkeyi src/instrumentation-client.ts kurar.
const subscribe = () => () => {};

export function TrustedTypesScript({ nonce, code }: { nonce?: string; code: string }) {
  const serverHtml = useSyncExternalStore(
    subscribe,
    () => false,
    () => true,
  );
  return serverHtml ? <script nonce={nonce} dangerouslySetInnerHTML={{ __html: code }} /> : null;
}
